// extracted by mini-css-extract-plugin
export default {"legal":"LegalCopy-module__legal___2y-0a"};